/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1IndividualpaymentFinancialPeopleMutationRequest,
  PostApiV1IndividualpaymentFinancialPeopleMutationResponse,
  PostApiV1IndividualpaymentFinancialPeople400,
  PostApiV1IndividualpaymentFinancialPeople401,
  PostApiV1IndividualpaymentFinancialPeople500,
} from "../../types/individualPaymentEditorsController/PostApiV1IndividualpaymentFinancialPeople.ts";

function getPostApiV1IndividualpaymentFinancialPeopleUrl() {
  const res = {
    method: "POST",
    url: `/api/v1/individualpayment/financial-people` as const,
  };
  return res;
}

/**
 * @description Cria o plano com descontos aprovados, parcela de matrícula (pendente com Nosso Número quando há valor; paga zerada quando não) e gera as mensalidades quando a matrícula permite. Bloqueia matrícula em seleção de pagamento. Migrado do legado IndividualPayment/FinancialPersonCreate POST. **(Requer Authorization para autenticação)**
 * @summary Cria o plano financeiro individual (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/financial-people}
 */
export async function postApiV1IndividualpaymentFinancialPeople(
  data?: PostApiV1IndividualpaymentFinancialPeopleMutationRequest,
  config: Partial<
    RequestConfig<PostApiV1IndividualpaymentFinancialPeopleMutationRequest>
  > & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiV1IndividualpaymentFinancialPeopleMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentFinancialPeople400
      | PostApiV1IndividualpaymentFinancialPeople401
      | PostApiV1IndividualpaymentFinancialPeople500
    >,
    PostApiV1IndividualpaymentFinancialPeopleMutationRequest
  >({
    method: "POST",
    url: getPostApiV1IndividualpaymentFinancialPeopleUrl().url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
